module.exports = __webpack_public_path__ + "static/3-aceptacion-2a4afcb428680d9ceb32a8652106b706.jpg";